<app-header></app-header>

<div class="row h100 exhibitor-backoffice">
  <div class="col-12 col-lg-2 h100 exhibitor-backoffice__left">
    <app-menu-exhibitor [active]="'exhibitors'"></app-menu-exhibitor>
  </div>
  <div class="col-12 col-lg-10 exhibitor-backoffice__right">

    <app-menu-exhibitor-sub-menu [active]="'detail-admin'" [exhibitor]="profile"></app-menu-exhibitor-sub-menu>

    <div class="exhibitor-backoffice__content" *ngIf="loader.count === 0">

      <form name="form" class="form" #form="ngForm">

        <h3>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.GENERAL' | translate }}</h3>
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group" [ngClass]="{ 'has-error': planId.invalid && (planId.dirty || planId.touched), 'has-success': planId.valid }">
              <label for="planId">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.CATALOGUE_PLAN_LABEL' | translate }}</label>
              <select id="planId" class="form-control" [(ngModel)]="profile['planId']" name="planId" #planId="ngModel" required>
                <option value="" disabled>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.CATALOGUE_PLAN_PLACEHOLDER' | translate }}</option>
                <option [value]="cataloguePlan['id']" *ngFor="let cataloguePlan of cataloguePlans">{{ utilsService._api(cataloguePlan.translations, 'name') }}</option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group" [ngClass]="{ 'has-error': status.invalid && (status.dirty || status.touched), 'has-success': status.valid }">
              <label for="status">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.STATUS_LABEL' | translate }}</label>
              <select id="status" class="form-control" [(ngModel)]="profile['statusId']" name="status" #status="ngModel" required>
                <option value="" disabled>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.STATUS_PLACEHOLDER' | translate }}</option>
                <option [value]="status['id']" *ngFor="let status of exhibitorStatuses">{{ utilsService._api(status.translations, 'translation') }}</option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group" [ngClass]="{ 'has-error': businessVisibility.invalid && (businessVisibility.dirty || businessVisibility.touched), 'has-success': businessVisibility.valid }">
              <label for="businessVisibility">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.BUSINESS_VISIBILITY_LABEL' | translate }}</label>
              <select id="businessVisibility" class="form-control" [(ngModel)]="profile['businessVisibility']" name="businessVisibility" #businessVisibility="ngModel" required>
                <option value="" disabled>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.BUSINESS_VISIBILITY_PLACEHOLDER' | translate }}</option>
                <option [value]="businessVisibility['value']" *ngFor="let businessVisibility of visibilityOptions">{{ businessVisibility.label | translate }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-12 col-md-4">
            <div class="form-group" [ngClass]="{ 'has-error': published.invalid && (published.dirty || published.touched), 'has-success mg-b20': published.valid }">
              <div>
                <label for="published">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.PUBLISHED_LABEL' | translate }}</label>
              </div>

              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" [(ngModel)]="profile['published']" name="optpublished" [value]="true" #published="ngModel">
                  {{ 'COMMON.YES' | translate }}
                </label>
              </div>
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" [(ngModel)]="profile['published']" name="optpublished" [value]="false" #published="ngModel">
                  {{ 'COMMON.NO' | translate }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group" [ngClass]="{ 'has-error': copyAllowed.invalid && (copyAllowed.dirty || copyAllowed.touched), 'has-success mg-b20': copyAllowed.valid }">
              <div>
                <label for="copyAllowed">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.ALLOW_EXHIBITOR_COPY_LABEL' | translate }}</label>
              </div>

              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" [(ngModel)]="profile['copyAllowed']" name="optcopyAllowed" [value]="true" #copyAllowed="ngModel">
                  {{ 'COMMON.YES' | translate }}
                </label>
              </div>
              <div class="form-check-inline">
                <label class="form-check-label">
                  <input type="radio" class="form-check-input" [(ngModel)]="profile['copyAllowed']" name="optcopyAllowed" [value]="false" #allowExhibitorCopy="ngModel">
                  {{ 'COMMON.NO' | translate }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group" [ngClass]="{ 'has-error': businessNoveltiesLimit.invalid && (businessNoveltiesLimit.dirty || businessNoveltiesLimit.touched), 'has-success': businessNoveltiesLimit.valid }">
              <label for="businessNoveltiesLimit">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.BUSINESS_NOVELTIES_LIMIT_LABEL' | translate }}</label>
              <input type="number" required class="form-control" [(ngModel)]="profile['businessNoveltiesLimit']" name="businessNoveltiesLimit" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.BUSINESS_NOVELTIES_LIMIT_PLACEHOLDER' | translate }}" #businessNoveltiesLimit="ngModel">
            </div>
          </div>

        </div>


        <h3>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN.USER_DETAIL' | translate }}</h3>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group" [ngClass]="{ 'has-error': catalogueUserName.invalid && (catalogueUserName.dirty || catalogueUserName.touched), 'has-success': catalogueUserName.valid }">
              <label for="catalogueUserName">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.CATALOGUE_USER_NAME_LABEL' | translate }}</label>
              <input type="email" required class="form-control" [(ngModel)]="profile['catalogueUserName']" name="catalogueUserName" placeholder="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_ADMIN_EDIT.CATALOGUE_USER_NAME_PLACEHOLDER' | translate }}" #catalogueUserName="ngModel">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <button type="button" class="btn btn--submit float-end" (click)="saveBtn()" [disabled]="!form.valid" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">
              {{ 'COMMON.SAVE' | translate }}
            </button>
            <button type="button" class="btn btn--light float-end mx-sm-3" (click)="cancel()">
              {{ 'COMMON.CANCEL' | translate }}
            </button>
          </div>
        </div>

      </form>

    </div>


  </div>
</div>

<app-footer></app-footer>
